import React from "react";
import { Icon, IconButton, InputAdornment, styled } from "@mui/material";
import PropTypes from "prop-types";
import { useController } from "react-hook-form";
import ControlMUItextField from "./ControlMUItextField";

const Input = styled("input")({
  display: "none",
});

const UploadFile = (props) => {
  const {
    name,
    control,
    defaultValue,
    onChange,
    icon,
    accept,
    setValue,
    iconDisable,
    multiple = false, // allow multi-file upload
    ...restProps
  } = props;

  const {
    formState: { errors },
    field: { onChange: fieldChange, value, ...fieldProps },
  } = useController({
    name,
    control,
    defaultValue: multiple ? defaultValue ?? [] : defaultValue ?? "",
  });

  const handleChangeShipment = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    if (multiple) {
      const newFiles = Array.from(files);
      const currentFiles = Array.isArray(value) ? value : [];
      const currentCount = currentFiles?.length || 0;
      const remainingSlots = 3 - currentCount;

      if (remainingSlots <= 0) {
        // Already at max
        return;
      }

      const newFilesSplice = newFiles.slice(0, remainingSlots);
      const mergedFiles = [...newFilesSplice, ...currentFiles];

      // Update RHF
      fieldChange(mergedFiles);

      // Update visible field
      const fileNames = mergedFiles.map((f) => f.name);
      setValue("fileName", fileNames.join(", "));
    } else {
      e.target.files?.item(0)?.name &&
        setValue("fileName", e.target.files.item(0).name, {
          shouldValidate: true,
        });
    }
  };

  return (
    <ControlMUItextField
      errors={errors}
      control={control}
      name="fileName"
      readOnly
      {...restProps}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <label htmlFor="icon-button-file">
              <Input
                {...fieldProps}
                disabled={iconDisable}
                value={value.filename}
                onChange={(e) => {
                  if (e.target.files.item(0)?.name) {
                    fieldChange(e.target.files);
                    handleChangeShipment(e);
                  }
                  onChange && onChange(e);
                }}
                onClick={(event) => {
                  if (!value) {
                    event.target.value = null;
                  }
                }}
                accept={accept}
                id="icon-button-file"
                type="file"
                multiple={multiple}
              />
              <IconButton
                disabled={iconDisable}
                color="default"
                aria-label="upload"
                component="span"
                size="large"
              >
                <Icon>{icon}</Icon>
              </IconButton>
            </label>
          </InputAdornment>
        ),
      }}
    />
  );
};

UploadFile.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  accept: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool, // 👈 new prop
};

export default UploadFile;
